import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '分类浏览', path: '/category' },
      { label: '文章中心', path: '/article' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '服务支持',
    links: [
      { label: '使用教程', path: '/article' },
      { label: '常见问题', path: '/#faq' },
      { label: '功能指南', path: '/category' },
      { label: '用户评价', path: '/about#reputation' },
    ],
  },
  {
    title: '联系方式',
    links: [
      { label: '在线客服', path: '/about#contact' },
      { label: '商务合作', path: '/about#contact' },
      { label: '意见反馈', path: '/about#contact' },
      { label: '加入我们', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                17c
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-400">
              17c是一个备受关注的平台，致力于为用户提供高效便捷的服务体验，帮助每一位用户实现目标。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 17c 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}